export const labelsPath = () => '/settings/labels' as const;
